<template>
  <div class="dashboard-block dashboard-block__release-count">
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1"
        y="1"
        width="54"
        height="54"
        rx="7"
        fill="white"
        stroke="#FF2289"
        stroke-width="2"/>
      <!-- eslint-disable max-len -->
      <path
        d="M39.9817 12.9533C39.9979 12.6618 39.8766 12.3784 39.6582 12.2003C39.4318 12.0141 39.1326 11.9574 38.8576 12.0303L22.3356 16.7506C21.9717 16.8558 21.721 17.1716 21.6886 17.5521L20.3785 37.0163C19.4889 36.4333 18.3244 36.2066 17.0708 36.3848C14.3778 36.7734 12.1458 38.8866 11.9921 41.1941C11.9193 42.2467 12.2913 43.2102 13.0435 43.9146C13.7956 44.619 14.855 44.9995 16.0357 44.9995C16.3026 44.9995 16.5856 44.9833 16.8606 44.9428C19.5536 44.5542 21.7857 42.441 21.9393 40.1335C21.9393 40.0282 21.9312 39.9311 21.9312 39.8339H21.9636L23.0149 24.1346L37.7254 19.9325L36.8924 32.296C36.0028 31.713 34.8383 31.4863 33.5848 31.6645C30.8918 32.0531 28.6597 34.1663 28.5061 36.4738C28.4333 37.5264 28.8053 38.4899 29.5574 39.1943C30.3095 39.8987 31.3689 40.2792 32.5496 40.2792C32.8165 40.2792 33.0996 40.263 33.3745 40.2225C36.0675 39.8339 38.2996 37.7207 38.4533 35.4132C38.4533 35.3079 38.4452 35.2108 38.4452 35.1136H38.4775L39.9655 12.9533H39.9817ZM16.6261 43.1697C15.6556 43.3154 14.7903 43.1049 14.2565 42.6029C13.9007 42.271 13.7309 41.8257 13.7632 41.3156C13.8603 39.8744 15.4939 38.4251 17.3215 38.166C17.5237 38.1336 17.7178 38.1255 17.9038 38.1255C18.6317 38.1255 19.2625 38.336 19.683 38.7328C20.0388 39.0647 20.2087 39.51 20.1763 40.0201C20.0793 41.4613 18.4457 42.9106 16.618 43.1697H16.6261ZM33.1481 38.4494C32.1776 38.587 31.3123 38.3846 30.7866 37.8826C30.4308 37.5507 30.261 37.1054 30.2933 36.5953C30.3904 35.1541 32.024 33.7048 33.8517 33.4457C34.0538 33.4133 34.2479 33.4052 34.4339 33.4052C35.1618 33.4052 35.7926 33.6157 36.2131 34.0125C36.5689 34.3444 36.7388 34.7897 36.7064 35.2998C36.6094 36.741 34.9758 38.1903 33.1481 38.4494ZM37.8629 18.0379L23.1524 22.24L23.4193 18.3051L38.1298 14.103L37.8629 18.0379Z"
        fill="#FF2289"
        stroke="#FF2289"
        stroke-width="0.5"
        stroke-miterlimit="10"/>
      <!-- eslint-enable max-len -->
    </svg>
    <div class="dashboard-block__release-count-label">
      今月の残り申請可能数
    </div>
    <span
      class="dashboard-block__release-count-value">
      {{ $store.state.auth.remaining_release_count }}曲
    </span>
    <small class="dashboard-block__release-count-reminder">※毎月1日にリセットされます</small>
  </div>
</template>
<script>
export default {
  name: 'RemainingMonthlyReleaseCount',
}
</script>
